// Router factory: the generated file-based route tree, router context (query client, auth; the provider's state replaces the initial placeholder on render), intent preloading and scroll restoration.
import type { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";

import { routeTree } from "@/__generated__/routeTree.gen";
import { INITIAL_AUTH, type AuthState } from "@/app/auth/useAuth";
import { RouteError } from "@/app/shell/RouteStates";

export interface RouterContext {
  queryClient: QueryClient;
  auth: AuthState;
}

export function createAppRouter(queryClient: QueryClient, auth: AuthState = INITIAL_AUTH) {
  return createRouter({
    routeTree,
    context: { queryClient, auth },
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0,
    defaultPendingMs: 300,
    defaultErrorComponent: RouteError,
    scrollRestoration: true,
  });
}

export type AppRouter = ReturnType<typeof createAppRouter>;

declare module "@tanstack/react-router" {
  interface Register {
    router: AppRouter;
  }
  interface StaticDataRouteOption {
    crumb?: string;
  }
}
